module.exports = __webpack_public_path__ + "favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./src/public/favicon.ico
// module id = 356
// module chunks = 0